import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import { usePreviewBulkMetaRowsStyles } from './styles';

/**
 * @param {Object} props
 * @param {Array<RowToRenderItemType>} [props.rowsToRender]
 */
const PreviewBulkMetaRows = ({ classes = {}, rowsToRender = [] }) => {
  const localClasses = usePreviewBulkMetaRowsStyles();
  const filteredRows = rowsToRender.filter(row => row.enabled);

  return filteredRows.map(row => (
    <Grid
      data-testid="bulk-meta-row"
      key={row.title}
      container
      item
      alignItems="center"
      wrap="nowrap"
      className={localClasses.previewBulkRow}
      {...row.RowProps}
    >
      <Grid item className={localClasses.title}>
        <Typography variant="body2" className={clsx(localClasses.titleItem, classes.disabled)}>
          {row.title}:
        </Typography>
      </Grid>
      <Grid item>
        {typeof row.render === 'string' ? (
          <Typography variant="body2" className={classes.disabled}>
            {row.render}
          </Typography>
        ) : (
          row.render
        )}
      </Grid>
    </Grid>
  ));
};

export default PreviewBulkMetaRows;
